import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import { getAccountByID, popup } from '../../../utils';
import { EDIT_ACCOUNT, EDIT_CUSTOMER, QUERY_KEYS, ROLES } from '../../../constants';
import { ManageUserBox } from './ManageUserBox';
import { Heading } from './Heading';
import { SectionBox } from './SectionBox';
import { PersonalInfoBox } from './PersonalInfoBox';
import { ManageCSMBox } from './ManageCSMBox';
import { ManagePlatformBox } from './ManagePlatformBox';
import { CircleSpinner } from '../../../assets/svg';
import { ManageSalesAgentBox } from './ManageSalesAgentBox';

export const EditCustomer = () => {
    const location = useLocation();
    const id = location?.state?.id;
    const selectedTpaId = useRef(undefined);
    const role = useSelector((s) => s?.user?.role);
    const [activeTab, setActiveTab] = useState(() =>
        [ROLES.SUPER_ADMIN, ROLES.ADMIN].includes(role) ? 0 : 2,
    );

    const {
        data: accountData,
        isError,
        error,
        isFetching,
    } = useQuery({
        queryKey: [QUERY_KEYS.ACCOUNT_BY_ID, id],
        queryFn: async () => await getAccountByID({ id: id }),
        select: (data) => data?.data || {},
        enabled: !!id,
    });

    // TODO: use if instead of useEffect
    if (isError) popup('error', error?.message);

    // tab switch
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className='edit-box-customer position-relative'>
            <Heading data={accountData || ''} heading={EDIT_CUSTOMER.HEADING} />
            <div className='tabs-set'>
                <div className='tabs-row d-flex align-items-center justify-content-start w-100 overflow-y-hidden overflow-x-auto'>
                    {EDIT_ACCOUNT.TABS_WITH_ROLES.map((tab) => {
                        return tab.allowedRoles.includes(role) ? (
                            <span
                                key={tab.name}
                                className={`d-flex align-items-center justify-content-center link-profile ${activeTab === tab.id ? 'active' : ''}`}
                                onClick={() => handleTabChange(tab.id)}
                            >
                                <span className='text-nowrap'>
                                    {role === ROLES.CSM ? tab.csm_name : tab.name}
                                </span>
                            </span>
                        ) : null;
                    })}
                </div>
                <div></div>
            </div>
            {isFetching ? (
                <CircleSpinner absolute size='3rem' />
            ) : (
                <SectionBox>
                    {activeTab === 0 && !isEmpty(accountData) && (
                        <PersonalInfoBox data={accountData} />
                    )}
                    {activeTab === 1 && !isEmpty(accountData) && (
                        <ManageCSMBox data={accountData} forRole={ROLES.CSM} />
                    )}
                    {activeTab === 2 && !isEmpty(accountData) && (
                        <ManageUserBox data={accountData} />
                    )}
                    {activeTab === 3 && !isEmpty(accountData) && (
                        <ManagePlatformBox
                            accountData={accountData}
                            selectedTpaId={selectedTpaId}
                        />
                    )}
                    {activeTab === 4 && !isEmpty(accountData) && (
                        <ManageSalesAgentBox data={accountData} />
                    )}
                </SectionBox>
            )}
        </div>
    );
};
